export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_TYPING_USERS_REQUEST = 'GET_TYPING_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const SET_USERS = 'SET_USERS';

export const getUsersRequest = (filters = {}) => ({
    type: GET_USERS_REQUEST,
    payload: {
        filters
    }
});

export const getTypingUsersRequest = (filters = {}) => ({
    type: GET_TYPING_USERS_REQUEST,
    payload: {
        filters
    }
});

export const getUsersSuccess = (users = [], total = 0, profiles) => ({
    type: GET_USERS_SUCCESS,
    payload: {
        users,
        total,
        profiles
    }
});

export const getUsersFailure = (error = {}) => ({
    type: GET_USERS_FAILURE,
    payload: {
        error
    }
});

export const setUsers = (users = [], total = 0) => ({
    type: SET_USERS,
    payload: {
        users,
        total
    }
});
